// Web module: notifications (lane ops). The outreach log: every reminder and notification the notifier sent or held
// back, read-only for everyone (entity: outreach). The generic detail page stays available at /outreach/<id>.
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    outreach: {
      ListPage: lazyComponent(() => import('./OutreachLogPage'), 'OutreachLogPage'),
    },
  },
  nav: [
    {
      key: 'outreach',
      label: 'Outreach log',
      to: '/outreach',
      group: 'Settings',
      order: 60,
      icon: 'events',
      entity: 'outreach',
    },
  ],
}
